import { SectionHead } from "./SectionHead";

const WHY = [
  ["Decisions, not demos", "Leaders are now expected to decide on AI — budgets, risk, workforce, regulation — not just to understand it."],
  ["The room does not exist yet", "The conversation happens in London, Paris and San Francisco. Norway has the companies and the capital, but not the room."],
  ["The window is 2027", "The choices boards make in the next eighteen months set their trajectory for a decade. Timing is the point."],
];

const SHIFT = [
  ["2019 – 2023", "The IT department", "Pilots, proofs of concept, a few enthusiasts."],
  ["2024 – 2026", "The budget line", "Real spend, real risk — and the first regulation, as the EU AI Act reaches Norway through the EEA."],
  ["2027", "The board agenda", "Strategy, workforce, capital. The year the decisions are made — and the year the room meets."],
];

export const WhyNow = () => (
  <section className="ns-sec pp" id="why" data-testid="ns-why">
    <div className="ns-wrap">
      <SectionHead nr="02" label="Why now" right="The 2027 theme" />
      <div className="ns-grid">
        <div className="g-1-9">
          <h2 className="ns-h2" data-rv data-testid="ns-why-h">AI has moved from the IT department to the board agenda.</h2>
        </div>
        <div className="g-1-6">
          <p className="ns-lede" data-rv data-testid="ns-why-lede">Three things have happened at once — and together they set the timing.</p>
        </div>
        <div className="g-1-12">
          <ol className="ns-ledger" data-rv data-testid="ns-why-ledger">
            {WHY.map(([t, d], i) => (
              <li key={t}><span className="k">0{i + 1}</span><span className="t">{t}</span><span className="d">{d}</span></li>
            ))}
          </ol>
        </div>
      </div>
      <p className="ns-k ns-shift-k" data-rv data-testid="ns-shift-k">The Next Shift — the 2027 theme, as a timeline</p>
      <ol className="ns-tl ns-shift" data-rv data-testid="ns-shift">
        {SHIFT.map(([y, t, d], i) => (
          <li key={y} className={i === SHIFT.length - 1 ? "hi" : ""}>
            <span className="t">{y}</span>
            <i className="pt" />
            <span className="l"><b>{t}</b>{d}</span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
